import React from "react";
import { Container, Form, Col, Button } from "react-bootstrap";
import "./SuperForm.css";

export default function SuperForm() {
  return (
    <Container className="super-form">
      <div>
        <h3>
          Upgrade Your Corporate Learning Strategy with Hub Educational Online
          For Business
        </h3>
      </div>
      <Form>
        <Form.Row>
          <Col>
            <Form.Group as={Col} controlId="formGridEmail">
              <Form.Label>First Name</Form.Label>
              <Form.Control placeholder="First Name " />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group as={Col} controlId="formGridEmail">
              <Form.Label>Last Name</Form.Label>
              <Form.Control placeholder="Last Name" />
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group as={Col} controlId="formGridEmail">
              <Form.Label>Company Name</Form.Label>
              <Form.Control placeholder="Company Name " />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group as={Col} controlId="formGridEmail">
              <Form.Label>Job Title</Form.Label>
              <Form.Control placeholder="Job Title" />
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            {" "}
            <Form.Group as={Col} controlId="formGridEmail">
              <Form.Label>Business Email</Form.Label>
              <Form.Control type="email" placeholder="Enter email" />
            </Form.Group>
          </Col>
        </Form.Row>

        <Form.Row>
          <Col>
            {" "}
            <Form.Group as={Col} controlId="formGridCity">
              <Form.Label>City</Form.Label>
              <Form.Control />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group as={Col} controlId="formGridState">
              <Form.Label>State</Form.Label>
              <Form.Control as="select" defaultValue="Choose...">
                <option>Choose...</option>
                <option>...</option>
              </Form.Control>
            </Form.Group>
          </Col>
        </Form.Row>

        <Form.Row>
          <Col>
            {" "}
            <Form.Group controlId="exampleForm.ControlTextarea1">
              <Form.Label>Describe your needs</Form.Label>
              <Form.Control as="textarea" rows={3} />
            </Form.Group>
          </Col>
        </Form.Row>

        <Button variant="primary" type="submit">
          Get in Touch
        </Button>
      </Form>
    </Container>
  );
}
